const ContactSection = () => {
  return (
    <section id="contact" className="w-full py-16 sm:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

        {/* セクションタイトル */}
        <p className="text-xs font-semibold tracking-widest mb-2" style={{ color: '#2C5AA0', letterSpacing: '0.15em' }}>
          CONTACT
        </p>
        <h2 className="text-2xl sm:text-3xl font-bold mb-3" style={{ color: '#1A1A1A' }}>
          お問い合わせ
        </h2>
        <div className="mx-auto mb-5" style={{ width: '48px', height: '2px', backgroundColor: '#2C5AA0' }}></div>
        <p className="text-sm sm:text-base leading-relaxed mb-2" style={{ color: '#555' }}>
          施工のご依頼・お見積りのご相談は、お電話またはメールにてお気軽にご連絡ください。
        </p>
        <p className="text-xs mb-10" style={{ color: '#888' }}>
          ※初回のご相談・現地確認は無料で承ります。
        </p>

        {/* 電話番号 */}
        <div
          className="mb-8 py-6 px-6 rounded-lg border border-gray-200"
          style={{ backgroundColor: '#F5F7FA' }}
        >
          <p className="text-xs font-semibold mb-2" style={{ color: '#666', letterSpacing: '0.1em' }}>
            お電話でのお問い合わせ
          </p>
          <a
            href="tel:0312345678"
            className="flex items-center justify-center gap-3 cursor-pointer group"
          >
            <div className="w-8 h-8 flex items-center justify-center rounded-full" style={{ backgroundColor: '#2C5AA0' }}>
              <i className="ri-phone-line text-base text-white"></i>
            </div>
            <span
              className="text-3xl sm:text-4xl font-bold tracking-wider group-hover:opacity-75 transition-opacity"
              style={{ color: '#2C5AA0' }}
            >
              03-1234-5678
            </span>
          </a>
          <p className="mt-2 text-xs" style={{ color: '#888' }}>
            受付時間：平日 8:00〜17:00（土日祝・年末年始を除く）
          </p>
        </div>

        {/* ボタングループ */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {/* メールボタン */}
          <a
            href="mailto:info@technoworks.co.jp?subject=施工・工事のご相談&body=【ご相談内容】%0A%0A【現場住所】%0A%0A【希望工期】%0A%0A【会社名・ご担当者名】%0A%0A"
            className="flex items-center justify-center gap-2.5 px-8 py-4 rounded-md border-2 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            style={{ borderColor: '#2C5AA0', color: '#2C5AA0', backgroundColor: '#fff', minWidth: '240px' }}
            onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#EEF2FA'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#fff'; }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line text-lg"></i>
            </div>
            メールで問い合わせる
          </a>

          {/* LINE公式アカウントボタン */}
          <a
            href="https://lin.ee/example"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center justify-center gap-2.5 px-8 py-4 rounded-md font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            style={{ backgroundColor: '#06C755', color: '#fff', minWidth: '240px' }}
            onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#05ae4a'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#06C755'; }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-message-2-line text-lg"></i>
            </div>
            LINE公式で相談する
          </a>
        </div>

        {/* 注意書き */}
        <p className="mt-6 text-xs leading-relaxed" style={{ color: '#aaa' }}>
          ご返信は翌営業日以降となる場合がございます。お急ぎの場合はお電話でご連絡ください。
        </p>
      </div>
    </section>
  );
};

export default ContactSection;
